import { IImageTitleAndValueProps } from "../../../models";

export const ImageTitleAndDescrComp = ({
  title,
  image,
  value,
}: IImageTitleAndValueProps) => {
  return (
    <div style={{ margin: "1rem 0" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}>
        <div style={{ marginLeft: "8px" }}>{image}</div>
        <div>
          <div>{title}</div>
          <div>{value}</div>
        </div>
      </div>
    </div>
  );
};
